import React from 'react';
import EksKFLWrapper from '../../shared/eks-lib/eksKFLwrapper';

interface Props {
  buttons: JSX.Element[];
}

const LogActions: React.FC<Props> = ({ buttons }) => {
  return (
    <EksKFLWrapper>
      {buttons.map((b, i) => (
        <span key={'log-btn-' + i}>{b}</span>
      ))}
    </EksKFLWrapper>
  );
};

export default LogActions;
